(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dutytek-article-page"]) return;
  try {
    
  const initialiseDutytekArticle = (root) => {
    const content = root.querySelector('[data-dta-content]');
    const toc = root.querySelector('[data-dta-toc]');
    const aside = root.querySelector('[data-dta-aside]');
    if (!content || !toc || !aside) return;

    const headings = [...content.querySelectorAll('h2')];
    const usedIds = new Set();

    headings.forEach((heading) => {
      let id = heading.id || heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');

      if (!id) id = 'article-section';
      let uniqueId = id;
      let suffix = 2;
      while (usedIds.has(uniqueId) || document.getElementById(uniqueId)) {
        if (heading.id === uniqueId) break;
        uniqueId = `${id}-${suffix}`;
        suffix += 1;
      }
      heading.id = uniqueId;
      usedIds.add(uniqueId);

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${uniqueId}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      toc.append(item);
    });

    if (headings.length > 1) aside.hidden = false;

    const factoryHeading = headings.find((heading) => heading.textContent.toLowerCase().includes('factory wheel and tyre size'));
    if (factoryHeading) {
      let element = factoryHeading.nextElementSibling;
      while (element && !/^H[23]$/.test(element.tagName)) {
        if (element.tagName === 'UL') {
          element.classList.add('dta-spec-list');
          break;
        }
        element = element.nextElementSibling;
      }
    }

    const importantParagraph = [...content.querySelectorAll('p')].find((paragraph) => paragraph.textContent.includes('4500kg GVM'));
    if (importantParagraph) {
      importantParagraph.classList.add('dta-important');
      const label = document.createElement('span');
      label.className = 'dta__important-label';
      label.textContent = root.dataset.importantLabel;
      importantParagraph.prepend(label);
    }
  };

  const initialiseDutytekArticles = () => {
    document.querySelectorAll('[data-dta-section]').forEach(initialiseDutytekArticle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseDutytekArticles, { once: true });
  } else {
    initialiseDutytekArticles();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dutytek-cart-page"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-quantity-control]');
    if (!control) return;
    const input = control.querySelector('[data-quantity-input]');
    let nextValue = Number.parseInt(input.value, 10) || 0;
    if (event.target.closest('[data-quantity-minus]')) nextValue = Math.max(0, nextValue - 1);
    if (event.target.closest('[data-quantity-plus]')) nextValue += 1;
    if (nextValue === Number.parseInt(input.value, 10)) return;
    input.value = nextValue;
    const form = control.closest('form');
    const updateButton = form?.querySelector('[data-cart-update]');
    if (form && updateButton) form.requestSubmit(updateButton);
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-quantity-input]')) return;
    const form = event.target.closest('form');
    const updateButton = form?.querySelector('[data-cart-update]');
    if (form && updateButton) form.requestSubmit(updateButton);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dutytek-contact-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-contact-topic]');
    if (!card) return;
    var select = document.getElementById('ContactForm-topic');
    if (!select) return;
    select.value = card.getAttribute('data-contact-topic');
    window.setTimeout(function () { select.focus(); }, 250);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dutytek-help-centre"] && !Shopify.designMode) return;
  try {
    
  function initialiseDutytekHelpCentres() {
    document.querySelectorAll('[data-help-centre]').forEach(function (section) {
      if (section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';
      var search = section.querySelector('[data-help-search]');
      var searchButton = section.querySelector('[data-help-search-button]');
      var filters = Array.from(section.querySelectorAll('[data-faq-filter]'));
      var items = Array.from(section.querySelectorAll('[data-faq-item]'));
      var empty = section.querySelector('[data-faq-empty]');
      var activeCategory = 'all';

      function applyFilters() {
        var term = search ? search.value.trim().toLowerCase() : '';
        var visible = 0;
        items.forEach(function (item) {
          var categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
          var textMatch = !term || item.textContent.toLowerCase().indexOf(term) !== -1;
          item.hidden = !(categoryMatch && textMatch);
          if (!item.hidden) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      }

      filters.forEach(function (filter) {
        filter.addEventListener('click', function () {
          var nextCategory = filter.dataset.faqFilter || 'all';
          activeCategory = activeCategory === nextCategory ? 'all' : nextCategory;
          filters.forEach(function (button) {
            button.setAttribute('aria-pressed', button.dataset.faqFilter === activeCategory ? 'true' : 'false');
          });
          applyFilters();
          var heading = section.querySelector('[id^="dt-help-faqs-"]');
          if (heading) heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      if (search) search.addEventListener('input', applyFilters);
      if (searchButton) searchButton.addEventListener('click', function () { applyFilters(); if (search) search.focus(); });
    });
  }

  document.addEventListener('DOMContentLoaded', initialiseDutytekHelpCentres);
  document.addEventListener('shopify:section:load', initialiseDutytekHelpCentres);
  initialiseDutytekHelpCentres();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dutytek-product-experience"] && !Shopify.designMode) return;
  try {
    
  const enhanceDutytekDescription = (content) => {
    if (content.dataset.dtEnhanced === 'true') return;

    const nodes = Array.from(content.childNodes);
    const introNodes = [];
    const groups = [];
    let activeGroup = null;

    nodes.forEach((node) => {
      const isHeading = node.nodeType === Node.ELEMENT_NODE && node.matches('h2, h3, h4');

      if (isHeading) {
        activeGroup = { heading: node, nodes: [] };
        groups.push(activeGroup);
      } else if (activeGroup) {
        activeGroup.nodes.push(node);
      } else {
        introNodes.push(node);
      }
    });

    if (groups.length < 3) {
      content.dataset.dtEnhanced = 'true';
      return;
    }

    const fragment = document.createDocumentFragment();
    introNodes.forEach((node) => fragment.append(node));

    groups.forEach((group, index) => {
      const title = group.heading.textContent.trim();
      const normalisedTitle = title.toLowerCase();
      const isFeatures = normalisedTitle.includes('feature') || normalisedTitle.includes('benefit');
      const isSteps = normalisedTitle.includes('how to use') || normalisedTitle.includes('installation');
      const isImportant = normalisedTitle.includes('compatib') || normalisedTitle.includes('vehicle lock') || normalisedTitle.includes('fitment') || normalisedTitle.includes('important');

      if (index < 2) {
        const groupElement = document.createElement('div');
        groupElement.className = 'dt-description-group';
        if (isFeatures) groupElement.classList.add('dt-description-group--features');
        if (isSteps) groupElement.classList.add('dt-description-group--steps');
        groupElement.append(group.heading, ...group.nodes);
        fragment.append(groupElement);
        return;
      }

      const details = document.createElement('details');
      details.className = 'dt-description-accordion';
      const summary = document.createElement('summary');
      const summaryTitle = document.createElement('span');
      const body = document.createElement('div');

      summaryTitle.textContent = title;
      body.className = 'dt-description-accordion__body';
      summary.append(summaryTitle);
      body.append(...group.nodes);

      if (isImportant) {
        const label = document.createElement('span');
        label.className = 'dt-description-accordion__label';
        label.textContent = content.dataset.importantLabel;
        summary.prepend(label);
        details.classList.add('dt-description-accordion--important');
        details.open = true;
      }

      details.append(summary, body);
      fragment.append(details);
    });

    content.replaceChildren(fragment);
    content.dataset.dtEnhanced = 'true';
  };

  const initialiseDutytekDescriptions = (scope = document) => {
    scope.querySelectorAll('.dt-product-description__content').forEach(enhanceDutytekDescription);
  };

  initialiseDutytekDescriptions();
  document.addEventListener('shopify:section:load', (event) => initialiseDutytekDescriptions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dutytek-search-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dutytek-search]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-search-tab]'));
    const products = Array.from(section.querySelectorAll('[data-search-result="product"]'));
    const guides = Array.from(section.querySelectorAll('[data-search-result="guide"]'));
    const filters = section.querySelector('[data-search-filters]');
    const callout = section.querySelector('[data-guide-callout]');

    const selectTab = (tabName) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.searchTab === tabName;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      products.forEach((card) => {
        card.hidden = tabName === 'guides';
      });

      guides.forEach((card) => {
        card.hidden = tabName !== 'guides' && products.length > 0;
      });

      if (filters) filters.hidden = tabName === 'guides';
      if (callout) callout.hidden = tabName !== 'all';
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => selectTab(tab.dataset.searchTab));
    });

    section.querySelectorAll('[data-open-guides]').forEach((button) => {
      button.addEventListener('click', () => {
        selectTab('guides');
        section.querySelector('[data-search-tab="guides"]')?.focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
